import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import StyledDiscountAddendum from './styles';
var DiscountAddendum = function DiscountAddendum() {
  var $ = _c(3);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      stringKey: "JP.discount_addendum",
      primaryValue: "Sale Price",
      description: "Sale price message for Japan"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var salePrice = useI18nString(t0);
  var t1;
  if ($[1] !== salePrice) {
    t1 = /*#__PURE__*/React.createElement(StyledDiscountAddendum, null, salePrice);
    $[1] = salePrice;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default DiscountAddendum;